import './scss/App.scss';
import React, {Component} from "react";
import LoginComponent from  "./auth/login";
import { Route, HashRouter, Switch,Redirect} from "react-router-dom";
import OrderDashboard from './components/Order/orderDashboard';
import OrderDetails from './components/Order/orderDetails';
import OrderCollection from "./components/Order/orderCollection";
import { ProtectedRoute }  from "./router/protected.route";
import OTPCustomer from "./components/otp/customer";
import CancelRescheduleRaiseAlertComponent from "./components/Order/cancelReschedule";
import DropLabCollection from "./components/labs/dropAtLabs";
import OTPLabs from './components/otp/labs';
import PhleboProfile from './components/phlebo/profile';
import PhleboPerformance from './components/phlebo/performance';
import LeaderboardProgressHub from './components/phlebo/LeaderboardProgressHub';
import AddVitals from "./components/collectVitals/addVitals";
import orderDetailsCollected from './components/Order/orderDetailsCollected';
import RescheduleToSameDay from './components/common/rescheduleSameDay';
import DependantOrderDashboard from './components/Order/dependantOrderDashboard';
import DependantOrderDetails from './components/Order/dependantOrderDetails';
import DependantOrderCollection from './components/Order/dependantOrderCollection';
import DependantOTPCustomer from './components/otp/dependantCustomer';
import DependantCancelRescheduleRaiseAlertComponent from './components/Order/dependantCancelReschedule';
import dependantOrderDetailsCollected from './components/Order/dependantOrderDetailsCollected';
import DependantRescheduleToSameDay from './components/common/dependantRescheduleSameDay';
import DropAllLabCollection from './components/labs/allDropAtLab';
import PackageSelection from './components/newUpsell/packageSelection';
import Checkout from './components/newUpsell/checkout';
import OrderTracker from './components/newUpsell/orderTracker';
import { UserBenefits } from "./components/newUpsell/benefits";
import { LabsPayment } from "./components/newUpsell/payment";

class App extends Component{
  constructor(props){
    super(props);
    this.state = {
      userExist : localStorage.getItem("access_token") ? true : false,
    }
  }

  render(){
    return(
        <div>
            <HashRouter>
              <Switch>
                <Route exact path="/order/:token?" component={OrderDashboard} />
                <Route exact path="/login/:token?" component={LoginComponent} />
                <Route exact path="/login" component={LoginComponent} />
                <Route exact path="/">
                    <Redirect to="/orders" />
                </Route>
                <ProtectedRoute exact path="/labs/userBenefits"  component={UserBenefits}/>
                <ProtectedRoute exact path="/labs/payment"  component={LabsPayment}/>
                <ProtectedRoute path="/orders/:orderStatus?" component={OrderDashboard} />
                <ProtectedRoute path="/dependantOrders/:orderStatus?" component={DependantOrderDashboard} />
                <ProtectedRoute path={`/sample/:orderId`} exact component={OrderDetails}/>
                <ProtectedRoute path={`/dependantSample/:dependantId`} exact component={DependantOrderDetails}/>
                <ProtectedRoute path={`/cancel/:orderId`} exact component={CancelRescheduleRaiseAlertComponent}/>
                <ProtectedRoute path={`/dependantCancel/:dependantId`} exact component={DependantCancelRescheduleRaiseAlertComponent}/>
                <ProtectedRoute path={`/sample/collected/:orderId`} exact  component={OrderCollection}/>
                <ProtectedRoute path={`/dependantSample/collected/:dependantId`} exact  component={DependantOrderCollection}/>
                <ProtectedRoute path={`/sample/collected/Reschedule/:orderId`} exact  component={RescheduleToSameDay}/>
                <ProtectedRoute path={`/dependantSample/collected/Reschedule/:orderId`} exact  component={DependantRescheduleToSameDay}/>
                <ProtectedRoute path={`/sample/collectedCompleted/:orderId`} exact  component={orderDetailsCollected}/>
                <ProtectedRoute path={`/dependantSample/collectedCompleted/:dependantId`} exact  component={dependantOrderDetailsCollected}/>
                <ProtectedRoute path={`/otp/customer/:orderId?`} exact  component={OTPCustomer}/>
                <ProtectedRoute path={`/dependantOtp/customer/:dependantId?`} exact  component={DependantOTPCustomer}/>
                <ProtectedRoute path={`/otp/labs/`} exact  component={OTPLabs}/>       
                <ProtectedRoute path={`/packageSelection`} exact  component={PackageSelection}/> 
                <ProtectedRoute path={`/checkout`} exact  component={Checkout}/>                
                <ProtectedRoute path={`/upsellOrders`} exact  component={OrderTracker}/>
                <ProtectedRoute path={`/allLabs/:orderId?`} exact  component={DropAllLabCollection}/>
                <ProtectedRoute path={`/labs/:orderId?`} exact  component={DropLabCollection}/>
                <ProtectedRoute path={`/profile`} exact component={PhleboProfile}/>
                <ProtectedRoute path={`/performance`} exact component={PhleboPerformance}/>
                <ProtectedRoute path={`/leaderboardProgressHub`} exact component={LeaderboardProgressHub}/>
                <ProtectedRoute path={`/collect/vitals/:orderId?`} exact  component={AddVitals}/>
                <Route path="*" component={() => "404 NOT FOUND"} />
              </Switch>
           </HashRouter>
        </div>
        )
    }
}
export default App;